import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { addDoc, collection } from "firebase/firestore";
import { db } from "./firebase";
import { useSnackbar } from "./SnackbarHandler";

const CreateAssessmentStyleDialog = ({
  open,
  onClose,
  onStyleCreated,
  userId,
}) => {
  const [styleName, setStyleName] = useState("");
  const [styleDescription, setStyleDescription] = useState("");
  const [creating, setCreating] = useState(false);
  const { showSnackbar } = useSnackbar();

  const handleCreate = async () => {
    if (!styleName.trim() || !styleDescription.trim()) {
      showSnackbar("Vänligen fyll i alla fält", "error");
      return;
    }

    setCreating(true);
    try {
      const docRef = await addDoc(collection(db, "assessmentStyles"), {
        name: styleName.trim(),
        description: styleDescription.trim(),
        userId: userId,
        createdAt: new Date(),
      });

      const newStyle = {
        id: docRef.id,
        name: styleName.trim(),
        description: styleDescription.trim(),
        userId: userId,
        createdAt: new Date(),
      };

      onStyleCreated(newStyle);
      showSnackbar("Bedömningsstil skapad och vald!", "success");
      setStyleName("");
      setStyleDescription("");
      onClose();
    } catch (error) {
      console.error("Error creating assessment style:", error);
      showSnackbar("Ett fel uppstod vid skapande av bedömningsstil", "error");
    } finally {
      setCreating(false);
    }
  };

  // In CreateAssessmentStyleDialog.js - change handleClose:
  const handleClose = () => {
    setStyleName("");
    setStyleDescription("");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          padding: 2,
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 600, fontSize: "1.3rem" }}>
        Skapa ny bedömningsstil
      </DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 3 }}>
          Skapa din egen bedömningsstil som du kan återanvända för framtida
          bedömningar.
        </Typography>

        <TextField
          autoFocus
          margin="dense"
          label="Namn på bedömningsstil"
          fullWidth
          variant="outlined"
          value={styleName}
          onChange={(e) => setStyleName(e.target.value)}
          placeholder="t.ex. Mycket uppmuntrande, Extra kritisk"
          sx={{ mb: 2 }}
        />

        <TextField
          margin="dense"
          label="Beskrivning/instruktion"
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          value={styleDescription}
          onChange={(e) => setStyleDescription(e.target.value)}
          placeholder="Beskriv hur bedömningen ska göras, vilken ton som ska användas, vad som ska fokuseras på..."
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 0 }}>
        <Button onClick={handleClose} variant="print" sx={{ display: "none" }}>
          Avbryt
        </Button>
        <Button onClick={handleCreate} variant="purp" disabled={creating}>
          {creating ? "Skapar..." : "Skapa"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateAssessmentStyleDialog;
